export { Uploads } from "./uploads.component";
